import type { MapSource } from '../map';

/**
 * The training garden: a plaza with four spawns, a pond (walk-blocking, shoot-over), hedge pockets and a
 * scarecrow shooting range in the south-east. Edit with the level-design skill.
 */
export const TRAINING_GARDEN: MapSource = {
  id: 'training-garden',
  name: 'Training Garden',
  rows: `
    ################################################
    #,,.....T.........,,,..........:.......T.....,,#
    #,.............................:...............#
    #.......~~~~~~.......c.........:.....######....#
    #..T...~~~~~~~~~...............:.....#....#..T.#
    #.....~~~~~~~~~~~.....,,.......:.....#..S.#....#
    #......~~~~~~~~~.......,,......:.....#....#....#
    #.,,.....~~~~~~.......T........:.....##..##....#
    #.,,...........................:...............#
    #......::::::::::::::::::::::::::::::::::::....#
    #......:..........======.......................#
    #..T...:.........========...T.....,,...........#
    #......:....c....==P==P==.........,,.......T...#
    #......:.........========......................#
    #,,....:....c....==P==P==....c.................#
    #,,....:.........========......................#
    #......:..........======...........::::::......#
    #......:...................T.......:....:......#
    #..T...:.......,,..................:....:......#
    #......:.......,,.......#######....:....:...T..#
    #......:::::::::::::::::#.....#::::::...:......#
    #...........T...........#..S..#.........:......#
    #.......................##...##...######:#######
    #.,,......c.......................#:::::::::::S#
    #.,,..............T...............#::::::::::::#
    #.................................#::S:::::::S:#
    #....T.......,,...........T......::::::::::::::#
    #.................................#:::::S::::::#
    #..........,,.....................#::::::::::S:#
    ################################################
  `,
};
